import React from "react";
import "./roadClosureWorkPermitAll.css";

const Template7CS = () => {
  return (
    <div className="rc_template-container">
      <div className="template-container-content underline-bottom">
        <div className="template-container-pera">
          <div className="cold-remark">
            <div className="template-heading">
              सामान्य अनुदेश / General Instruction
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>1.</span>
              <div>
                Work permit shall be filled completely in all respect.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>2.</span>
              <div>
                Ensure signature of work permit holder and concerned authorities.
              </div>
            </div>

             <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>3.</span>
              <div>
                Separate clearance to be obtained for each job.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>4.</span>
              <div>
                Identify & eliminate hazards to the extent possible by proper site preparation.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>5.</span>
              <div>
                Ensure that job site is safe to carry out the work, specify the safety requirement stipulation.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>6.</span>
              <div>
                Work permit should be available with executing/performing agency at job site at all times.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>7.</span>
              <div>
                Alternate means of escape shall be provided whenever necessary. In case of fire siren or if instructed stop the job. All personnel must leave worksite and should follow instructions of supervisor and/or proceed to the nearest safe (designated) Emergency assembly point.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>8.</span>
              <div>
                In case of fire or release of flammable liquid/toxic gas, stop all the work activities, inform area operating personnel.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>9.</span>
              <div>
                Only certified vehicles/engines/electrical equipment/tools are allowed in operating areas of plant under valid permit.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>10.</span>
              <div>
                The excavation clearance/Road closure work permit shall be valid for eight hours for the same job. The renewal can be made on the same permit daily. Work permit can be extended for maximum seven days for the same nature of job. Then onwards a new permit will have to be obtained for the continued jobs.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>11.</span>
              <div>
                When excavation is required to be carried out in an area where there are cables (electrical, instrument or information systems) and there are underground pipelines, the excavation work permits will be initially issued for one day. If there are no cables and pipelines found, the permit can be extended to next shift/next day up to one more week. Then onwards, a new permit will be issued every week with validity for one week.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>12.</span>
              <div>
                Work permit shall never be issued directly to contractor employee.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "40px", paddingRight: "20px" }}>13.</span>
              <div>
                Ensure proper use of Personal Protective Equipments by personnel involved.
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Template7CS;
